import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController } from 'ionic-angular';
import { NgForm } from '@angular/forms/src/directives/ng_form';

@IonicPage()
@Component({
  selector: 'page-modal-activar-alineaciones',
  templateUrl: 'modal-activar-alineaciones.html', 
})
export class ModalActivarAlineacionesPage {

  //#region Propiedades del controlador
  public explicacion:string = "";
  //#endregion

  constructor(public navCtrl: NavController, public navParams: NavParams, public viewCtrl:ViewController) {
  }

  ionViewDidLoad() {
    
  }

  //#region Métodos del controlador

  public Guardar(form:NgForm):void{
    if (form.valid){
      this.viewCtrl.dismiss(this.explicacion);
    }
  }

  //#endregion
}



// WEBPACK FOOTER //
// ./src/pages/modal-activar-alineaciones/modal-activar-alineaciones.ts